import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Chip,
  Stack,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
} from '@mui/material';
import {
  LocationOn,
  SquareFoot,
  Directions,
  AttachMoney,
  CheckCircle,
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
import ExploreIcon from '@mui/icons-material/Explore';


const BookedProjectPlotDetails = ({ data }) => {

  const theme = useSelector((data) => data.themeValue.colors)
  return (
    <Box sx={{ p: { xs: 2, sm: 4 }, maxWidth: '1200px', mx: 'auto' }}>
      {/* Header */}
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, sm: 2 },
          mb: 3,
          borderRadius: 3,
          background: theme.background,
          backdropFilter: 'blur(10px)',
          border: `1px solid ${theme.borderColor}`,

        }}
      >
        <Typography variant="h5" fontWeight={500} sx={{ color: theme.text }} gutterBottom>
           BOOKED PLOTS
        </Typography>
       
        {/* <Chip
          label={`${data.plots.length} Plot(s) Booked`}
          color="success"
          icon={<CheckCircle fontSize="small" />}
        /> */}
      </Paper>
      {/* Horizontally Scrollable Plots */}
      <Box
        sx={{
          display: 'flex',
          overflowX: 'auto',
          gap: 2,
          pb: 2,
          // scrollSnapType: 'x mandatory',
          // '&::-webkit-scrollbar': {
          //   height: '8px',
          // },
          // '&::-webkit-scrollbar-thumb': {
          //   backgroundColor: '#ccc',
          //   borderRadius: '4px',
          // },
        }}
      >
        {data.plots.map((plot, index) => (
          <Box
            key={index}
            sx={{
              minWidth: { xs: '280px', sm: '300px', md: '340px' },
              scrollSnapAlign: 'start',
              flexShrink: 0,
            }}
          >
            <Paper
              elevation={3}
              sx={{
                p: 3,
                borderRadius: 3,
                backgroundColor: theme.background,
                transition: '0.3s ease',
                height: '100%',
                // '&:hover': {
                //   boxShadow: 6,
                //   transform: 'translateY(-2px)',
                // },
                border: `1px solid ${theme.borderColor}`,
              }}
            >
              <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1} sx={{textAlign:"center",alignItems:"center"}}>
                <Typography variant="h6" noWrap sx={{ color: theme.text }}>
                  {plot.PropertyName}
                </Typography>

                <Typography  noWrap sx={{ color: theme.text }}>
                  <ExploreIcon fontSize="small" sx={{ color: theme.normal_icon,marginRight:"5px" }} />
                  {plot.Facing}
                </Typography>
              </Stack>
              <List dense>
                <ListItem disableGutters>
                  <ListItemAvatar>  
                    <Avatar sx={{ bgcolor: 'primary.light' }}>
                      <SquareFoot fontSize="small" />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={`${plot.SizeInSqFt} sqft`} secondary="Size" sx={{
                    color: theme.text, '& .MuiListItemText-secondary': {
                      color: theme.text,
                    },
                   }} />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: 'success.light' }}>
                      <AttachMoney fontSize="small" />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={`₹${plot.SqFtPrice.toLocaleString()}`}
                    secondary="SqFt Price"
                    sx={{
                      color: theme.text,
                      '& .MuiListItemText-secondary': {
                        color: theme.text,
                      },
                    }}
                  />
                </ListItem>
              </List>
              
            </Paper>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
export default BookedProjectPlotDetails;